import React from 'react';
import HomeEyeCheckUp from '../HomeEyeCheckUp/HomeEyeCheckUp';
import { Link } from 'react-router-dom';
import GridMenu from '../Menu/GridMenu';
import ContactLens from '../Menu/ContactLens';
import Menu from '../Menu/Menu';
import './MainMenu.scss';

const redirection = (key, data, props) => {
    const {updateNavValueDtm} = props;
    return data.url && data.url.indexOf('lenskart.com') === -1 ?
    <Link className="" to={{ pathname: data.url, state: { categoryId: data.categoryId, section: 'cat' } }} onClick={() => updateNavValueDtm(key, '', '', '')}>{key}</Link> :
    <a className="" onClick={() => updateNavValueDtm(key, '', '', '')} href={data.url}>{key}
    </a>;
};
const MainMenu = props => {
    const { updateNavDtm, navData, updateNavValueDtm, location, dataLocale } = props;
    return (
        <div id="cssmenu" className="main-menu fs15"> {
            navData.menu ? navData.menu.map(data => {
                let itemlists = '';
                return Object.keys(data).map((key, index) => {
                    if (data[key].type === 'two-col-layout') {
                        itemlists = <div key={index} className={data[key].url === location.pathname ? 'nav-level-1 try-at-home active-nav' : 'nav-level-1 try-at-home'}><a><span>{key}</span></a><HomeEyeCheckUp dataLocale={dataLocale} parentMenu={data} menuData={data[key]} updateNavDtm={updateNavDtm} section={key} cta={data[key].cta} /></div>;
                    } else if (data[key].type === 'grid') {
                        itemlists = <div key={index} className="nav-level-1 grid"><a><span>{key}</span></a><GridMenu dataLocale={dataLocale} menuData={data[key]} updateNavValueDtm={updateNavValueDtm} parentMenu={data[key]} section={key} /></div>;
                    } else if (data[key].type === 'list-grid') {
                        itemlists = <div key={index} className={data[key].url === location.pathname ? 'nav-level-1 active-nav' : 'nav-level-1'}>{redirection(key, data[key], props)}<ContactLens menuData={data[key]} parentMenu={data} updateNavValueDtm={updateNavValueDtm} section={key} /></div>;
                    } else if (data[key].type === 'three-col-layout') {
                        itemlists = <div className={data[key].url === location.pathname ? 'nav-level-1 active-nav three-col-layout' : 'nav-level-1 three-col-layout'} key={index}>{redirection(key, data[key], props)}<Menu dataLocale={dataLocale} menuData={data[key]} parentMenu={data} updateNavValueDtm={updateNavValueDtm} section={key} /></div>;
                    } else {
                        itemlists = <div key={index} className={data[key].url === location.pathname ? 'nav-level-1 active-nav' : 'nav-level-1'}>{redirection(key, data[key], props)}</div>;
                    }
                    return (
                        itemlists
                    );
                });
            }) : ''
        } </div>
    );
};

MainMenu.defaultProps = {
    navData: {}
};

export default MainMenu;
